//SSKCOMPANY
export const ALL_SSKCOMPANY_REQUEST = "ALL_SSKCOMPANY_REQUEST";
export const ALL_SSKCOMPANY_SUCCESS = "ALL_SSKCOMPANY_SUCCESS";
export const ALL_SSKCOMPANY_FAIL = "ALL_SSKCOMPANY_FAIL";

export const ALL_SSKCOMPANY_COMPANY_REQUEST = "ALL_SSKCOMPANY_COMPANY_REQUEST";
export const ALL_SSKCOMPANY_COMPANY_SUCCESS = "ALL_SSKCOMPANY_COMPANY_SUCCESS";
export const ALL_SSKCOMPANY_COMPANY_FAIL = "ALL_SSKCOMPANY_COMPANY_FAIL";